// extracted by mini-css-extract-plugin
export default {"heads":"PIP_heads__0QaMH","main":"PIP_main__-Zqe2","goals":"PIP_goals__73NEl","btn":"PIP_btn__njLJV"};